// extracted by mini-css-extract-plugin
export default {"root":"GeneralDetails_root__CWhtj","display-pic-input":"GeneralDetails_display-pic-input__jCRkm"};